// アプリの いいね を切り替える（一覧のカードと詳細の両方から使う）。
// 以前は各部品が別々に持っていて、次の 3 つの問題があった
// - 表示を先に変えたまま、失敗しても元に戻さない
// - 1 秒以上あけて押す・取り消すと POST と DELETE が並んで飛び、届く順番で表示と DB が逆になる
// - 部品を作ったときの利用者の uid を使い続ける（利用者を切り替えると前の子の uid で いいね する）
import { toast } from "react-toastify";
import { useStore, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "app/store";
import I18n from "common/i18n";
import { actions } from "features/creator/slice";
import { ProjectEntity } from "features/creator/types";
import { favoriteProject, stopFavoriteProject } from "features/creator/api";

/** 送っている最中のアプリ。終わるまで同じアプリは押しても何もしない（要求を並べない） */
const inFlight = new Set<string>();

export const useToggleFavorite = () => {
  const store = useStore<RootState>();
  const dispatch = useDispatch<AppDispatch>();

  return async (project: ProjectEntity) => {
    const uid = store.getState().user.active?.uid;
    if (!uid || inFlight.has(project.project_id)) return;
    inFlight.add(project.project_id);
    const before = { favorited: project.favorited, is_favorited: project.is_favorited };
    dispatch(
      actions.updateProjectFavorited({
        project_id: project.project_id,
        favorited: before.is_favorited ? before.favorited - 1 : before.favorited + 1,
        is_favorited: !before.is_favorited,
      }),
    );
    try {
      if (before.is_favorited) {
        await stopFavoriteProject({ uid, project_id: project.project_id });
      } else {
        await favoriteProject({ uid, project_id: project.project_id });
      }
    } catch {
      // 送れなかったら表示を元に戻す
      dispatch(actions.updateProjectFavorited({ project_id: project.project_id, ...before }));
      toast.warn(
        <div>
          <p className="type-text type-sm text-textcolor-black">{I18n.t("MSG_TOAST_FAILED")}</p>
        </div>,
      );
    } finally {
      inFlight.delete(project.project_id);
    }
  };
};
